<template>
    <div class="blase">
        <p class="titel">{{ titel }}</p>
        <p class="text">{{ schritt.text }}</p>

        <p class="zaehler" v-if="anzahl > 1">Schritt {{ index + 1 }} von {{ anzahl }}</p>

        <div class="knoepfe">
            <button @click="$emit('zurueck')" :disabled="index === 0">Zurück</button>
            <button class="weiter" v-if="kannWeiter" @click="$emit('weiter')">Weiter</button>
            <button class="schliessen" @click="$emit('schliessen')">Schliessen</button>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        titel: String,
        schritt: Object,
        index: Number,
        anzahl: Number,
        // Ob es ueberhaupt noch weitergeht — im Thema oder in der Gruppe.
        // Entscheidet Funkgeraet.vue, nicht die Blase: nur dort ist bekannt,
        // welches Thema als naechstes kommt.
        kannWeiter: Boolean
    }
}

</script>

<style scoped>
/* Steht oben in der Seitenspalte; die Spalte liegt waehrend einer
   Erklaerung als Ganzes ueber der Abdunklung (Funkgeraet.vue). */
/* Bleibt oben in der Spalte stehen, waehrend die Liste darunter scrollt. */
.blase {
    position: sticky;
    top: -1.25rem; /* buendig mit der Oberkante der Spalte (deren Innenabstand) */
    z-index: 1;
    margin: 0 0 1.25rem;
    padding: 1rem 1.1rem 0.9rem;
    background: var(--zs-flaeche);
    border: 1px solid var(--zs-rahmen);
    border-radius: var(--zs-ecke);
    box-shadow: 0 8px 16px -12px rgba(31, 35, 40, 0.35);
    text-align: left;
}

.titel {
    margin: 0 0 0.35rem;
    font-size: 1.15rem;
    font-weight: 700;
    line-height: 1.3;
    color: var(--zs-tinte);
}

.text {
    margin: 0 0 0.6rem;
    font-size: 1rem;
    line-height: 1.5;
    color: var(--zs-tinte);
}

.zaehler {
    margin: 0 0 0.75rem;
    font-size: 0.85rem;
    color: var(--zs-grau);
}

.knoepfe {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
}

/* Dieselben Knopfarten wie in der Spalte: Weiter = Haupt, Zurueck =
   Neben, Schliessen = Text. */
button {
    min-height: 2.5rem;
    padding: 0.45rem 0.95rem;
    font: inherit;
    font-size: 0.95rem;
    font-weight: 500;
    color: var(--zs-tinte);
    background: #ffffff;
    border: 1px solid var(--zs-rahmen);
    border-radius: var(--zs-ecke);
    cursor: pointer;
}

button:hover:not(:disabled) {
    border-color: var(--zs-grau);
}

button:disabled {
    color: var(--zs-grau);
    opacity: 0.5;
    cursor: default;
}

.weiter {
    color: #ffffff;
    background: var(--zs-blau);
    border-color: var(--zs-blau);
}

.weiter:hover:not(:disabled) {
    background: var(--zs-blau-dunkel);
    border-color: var(--zs-blau-dunkel);
}

.schliessen {
    margin-left: auto;
    padding-inline: 0.5rem;
    font-weight: 400;
    color: var(--zs-grau);
    background: transparent;
    border-color: transparent;
}

.schliessen:hover:not(:disabled) {
    color: var(--zs-tinte);
    border-color: transparent;
    text-decoration: underline;
    text-underline-offset: 3px;
}

button:focus-visible {
    outline: 3px solid var(--zs-orange);
    outline-offset: 2px;
}
</style>
